import { render } from "./ImageLoadError.vue?vue&type=template&id=1f38c8a1&ts=true"
import script from "./ImageLoadError.vue?vue&type=script&lang=ts"
export * from "./ImageLoadError.vue?vue&type=script&lang=ts"

import "./ImageLoadError.vue?vue&type=style&index=0&id=1f38c8a1&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__